var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"div",staticClass:"m-wx fixed z-50",style:({ bottom: _vm.bottom }),attrs:{"draggable":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }